<script setup lang="ts">
import { UserStore } from "@/store/userStore";

const userStore = UserStore();
const backgroundColor = ref();
const root = document.documentElement;

watch(
  () => userStore.theme,
  (newVal) => {
    console.log(newVal);
    backgroundColor.value = getComputedStyle(root)
      .getPropertyValue("--color-background")
      .trim();
  }
);

onMounted(() => {
  backgroundColor.value = getComputedStyle(root)
    .getPropertyValue("--color-background")
    .trim();
});
</script>
<template>
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="19" height="19" rx="9.5" fill="#658CD8" />
    <path
      d="M9.73215 6.51748L11.8158 8.60117L7.2913 13.1258L5.4336 13.3309C5.1849 13.3584 4.97479 13.1481 5.00246 12.8994L5.20916 11.0403L9.73215 6.51748ZM13.1045 6.20725L12.1261 5.22889C11.821 4.9237 11.326 4.9237 11.0209 5.22889L10.1005 6.14931L12.1841 8.233L13.1045 7.31258C13.4096 7.00724 13.4096 6.51244 13.1045 6.20725Z"
      :fill="backgroundColor"
    />
  </svg>
</template>
<style scoped>
svg {
  cursor: pointer;
}
</style>
